import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, UserCircle } from 'lucide-react';

export function CharacterDetail() {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="container mx-auto px-4 py-8">
      <Link
        to="/characters"
        className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Characters
      </Link>

      <div className="flex items-center gap-3 mb-6">
        <UserCircle className="w-8 h-8 text-blue-600" />
        <h1 className="text-3xl font-bold">Character {id}</h1>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Character details coming soon...</p>
      </div>
    </div>
  );
}
